import fetch from '../../utils/fetch'

export function getRecordByPlateNo(params) {
    return fetch({
        url: '/api/parkrec/venue',
        method: 'GET',
        params
    })
}


export function order(params) {
    return fetch({
        url: '/api/order',
        method: 'POST',
        data: params
    })
}

export function getParkinglotInfo(id) {
    return fetch({
    url: '/api/parkinfo/' + id,
        method: 'GET',
    })
}

export function pay(params) {
    return fetch({
        url: '/api/pay/unionOrder',
        method: 'POST',
        data: params
    })
}

export function getPrecomputation(params) {
    return fetch({
        url: '/api/feescale/precomputation',
        method: 'GET',
        params
    })
}
